import dayjs from "dayjs";
import {CancelToken} from "axios";

import baseApi from "shared/networking/baseApi";
import {getMeta} from "shared/networking/tools";
import {TERM_100UL, TERM_105_UL, TERM_LIFETIME} from "../constants/terms";
import {PREFERRED, STANDARD_PLUS, SUPER_PREFERRED} from "shared/constants/rateClasses";


const widgetToken = getMeta('agencyToken');


function parseProducts(results) {
    return results.map(item => ({
        id: item.id,
        image: item.company.logo,
        name: item.name,
        company: item.company.name,
        companyRatings: item.company.ratings,
        premium: {
            amount: item.premiums.total,
            period: item.premiums.period,
        },
        premiumByPeriod: item.premiums.premiums_by_period,
        term: item.term,
        rateClass: `${item.rate_class_name}`,
    }));
}

// TODO: THIS IS HORRIBLE, IF YOU FIND A BETTER WAY CHANGE IT
function getHealthValue(rateClass, tableRating) {
    const healthValueByRateClass = {
        [SUPER_PREFERRED]: 5,
        [PREFERRED]: 4,
        [STANDARD_PLUS]: 3,
    };

    // TODO: DELETE
    console.log('health value', rateClass, healthValueByRateClass, healthValueByRateClass[rateClass]);

    if (healthValueByRateClass[rateClass]) {
        return healthValueByRateClass[rateClass];
    }

    // Only standard rate class
    return tableRating ? 1 : 2;
}

// TODO: THIS IS HORRIBLE, IF YOU FIND A BETTER WAY CHANGE IT
function getTerm(terms) {
    if (terms.length === 1) {
        return terms[0];
    }

    // If it has more than one, it is the lifetime option
    return TERM_100UL;
}

function parseQuoteInput(data) {
    const rateClass = data.rate_class?.toString();
    const tableRating = data.table_rating?.toString();
    return {
        dob: data.birthdate ? dayjs(data.birthdate) : undefined,
        gender: data.sex?.toString(),
        smoking: data.smoking?.toString(),
        state: data.state,
        payment: data.payment?.toString(),
        amount: parseInt(data.amount, 10),
        rateClasses: [rateClass],
        tableRating: tableRating,
        healthValue: getHealthValue(rateClass, tableRating),
        term: getTerm(data.terms),
    };
}

export async function runQuote(quoteInput, allowTickets, agentId, showClientView, cancelSignal) {
    const {
        dob,
        gender,
        smoking,
        state,
        payment,
        amount,
        rateClasses,
        term,
        tableRating,
    } = quoteInput;

    const {ageLast, ageNearest} = getAgeLastAndNearest(dob);

    let terms;
    if (term === TERM_LIFETIME) {
        terms = [TERM_100UL, TERM_105_UL];
    } else {
        terms = [term];
    }

    const source = CancelToken.source();
    cancelSignal.addEventListener('abort', () => {
        source.cancel();
    });

    let payload = {
        "age_last": ageLast.toString(),
        "age_nearest": ageNearest.toString(),
        state,
        "sex": gender,
        "birthdate": dayjs(dob).format("YYYY-MM-DD"),
        smoking,
        "amount": amount.toLocaleString('en-US'),
        payment,
        "terms": terms,
        "rate_classes": rateClasses,
        "table_rating": tableRating,
        "allow_tickets": allowTickets,
        "show_client_view": showClientView,
    }
    if (agentId) {
        payload['agent_id'] = agentId;
    }

    const response = await baseApi.post(
        '/api/quotes/',
        payload,
        {
            headers: {
                'Authorization': `Token ${widgetToken}`,
            },
            cancelToken: source.token,
        },
    );

    const products = parseProducts(response.data.results);
    return {
        id: response.data.id,
        savePdf: response.data.save_pdf,
        products,
    };
}

export async function getQuote(quoteToken) {
    const response = await baseApi.get(
        `/api/quotes/${quoteToken}/`,
        {
            headers: {
                'Authorization': `Token ${widgetToken}`,
            },
        },
    );

    const products = parseProducts(response.data.results);
    const input = parseQuoteInput(response.data);

    return {
        input,
        result: {
            id: response.data.id,
            savePdf: response.data.save_pdf,
            products,
        },
    };
}

export async function applyProduct(
    quoteRequestId,
    productId,
    premium,
    lengthOfCoverage,
    showClientView = true,
    allowTickets = true,
) {
    const response = await baseApi.post(
        '/applications/',
        {
            'quote_request_id': quoteRequestId,
            'product_id': productId,
            'premium': premium && premium.amount,
            'premium_frequency': premium && premium.period,
            'length_of_coverage': lengthOfCoverage,
            'quoter_url': window.location.href,
            'show_client_view': showClientView,
            'allow_tickets': allowTickets,
            'agency_name': getMeta("agencyName"),
        },
    );
    const {application_url: applicationUrl} = response.data;
    return {applicationUrl};
}

function getAgeLastAndNearest(date) {
    const birthdate = dayjs(date),
        year = birthdate.year(),
        today = dayjs().hour(0).minute(0).second(0),
        thisYearBirthday = birthdate.year(today.year());

    // Calculate current age.
    let offset = -1 * (today < thisYearBirthday);
    let ageLast = today.year() - year + offset;

    // Calculate nearest age (either current age or one year older).
    let nextBirthday, lastBirthday;
    if (offset === -1) {
        nextBirthday = thisYearBirthday;
        lastBirthday = nextBirthday.year(nextBirthday.year() - 1);
    } else {
        lastBirthday = thisYearBirthday;
        nextBirthday = lastBirthday.year(lastBirthday.year() + 1);
    }

    let ageNearest;
    if (nextBirthday - today < today - lastBirthday) {
        ageNearest = ageLast + 1;
    } else {
        ageNearest = ageLast;
    }

    return {
        ageLast,
        ageNearest,
    };
}
